import React from 'react';
import './OnboardingContent.css';
import OBIMG from '../../assets/images/onbording.png'; 

const OnboardingContent = () => {
  return (
    <section className="onboarding-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="onboarding-intro-grid">
          <div className="onboarding-intro-image-container">
            <img 
              src={OBIMG} 
              alt="SAP Onboarding" 
              className="onboarding-intro-image"
            />
          </div>
          <div className="onboarding-intro-text">
            <h2 className="onboarding-intro-title">A Seamless Welcome with SAP SuccessFactors Onboarding</h2>
            <p>
              First impressions matter. The SAP SuccessFactors Onboarding solution ensures a strategic, welcoming, and efficient experience for new hires, connecting them to the people, content, and tools they need to become productive members of your team from day one.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="onboarding-features-grid">
          <div className="onboarding-feature-card">
            <h3>Engage New Hires Early</h3>
            <p>
              Engage new employees before their first day with a personalized onboarding portal. Provide access to important documents, introduce them to their team, and share company culture content to make them feel welcome and prepared.
            </p>
          </div>
          <div className="onboarding-feature-card">
            <h3>Automate Paperwork & Processes</h3>
            <p>
              Eliminate manual paperwork with digital forms and e-signatures. Automate the entire process, from creating a new employee profile to assigning equipment and scheduling initial training sessions, ensuring compliance and accuracy.
            </p>
          </div>
          <div className="onboarding-feature-card">
            <h3>Connect New Hires with Key People</h3>
            <p>
              Facilitate crucial connections by introducing new hires to their managers, mentors, and teammates. The system can guide them through setting up initial meetings and understanding key contacts within the organization.
            </p>
          </div>
          <div className="onboarding-feature-card">
            <h3>Measure and Improve Onboarding Success</h3>
            <p>
              Utilize dashboards and analytics to track the progress of new hires and measure the effectiveness of your onboarding program. Gain insights to continuously improve the process and accelerate time-to-productivity for new employees.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnboardingContent;
